
import StringUtil from "vamos/cockpit/base/util/StringUtil";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import V4Context from "sap/ui/model/odata/v4/Context";
import TimeUtil from "vamos/cockpit/util/TimeUtil";

export default class JsonUtil {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    public static capitalizeFirstLetters(oObject) {
        if (!oObject) {
            throw new Error("no Object");
        }
        const oNewObject = {};
        for (const sParam in oObject) {
            const sCapitalizedParam = StringUtil.capitalizeFirstLetter(sParam);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
            oNewObject[sCapitalizedParam] = oObject[sParam];
        }
        return oNewObject;
    }
    public static json2OData(context:V4Context, data:object, updateGroupId: string  = "changes") {
        const oDataModel: ODataModel= context.getModel();
        const metaModel = oDataModel.getMetaModel();
        const metaPath = metaModel.getMetaPath(context.getPath());
        for(const parameterName in data) {
            const metaData:any =metaModel.getObject(`${metaPath}/${parameterName}`);

            if(!metaData || metaData.$kind === 'NavigationProperty') continue;
            const type:string = metaData.$Type as string;
            const value:string|number|Date = this.parseValue(data[parameterName], type);
            try{
                void context.setProperty(parameterName, value, updateGroupId)

            } catch(e){
                console.error(e);
            }

        }

    }
    private static parseValue(value:Date|string|number, type:string):Date|string|number {
            if(type === "Edm.DateTimeOffset"){
                value = TimeUtil.formatIntoV4Date(value as string);
            } else if (type === "Edm.Int32" && typeof value === "string"){
                value = parseInt(value);
            } else if(type === "Edm.Double" && typeof value === "string"){
                value = parseFloat(value.replace(",","."));
        }
            return value;
    }
}